namespace TabAurous.Common {
    export interface ItemsRegisterFiltersForm {
        VoucherTypeId: _Ext.EmptyLookupEditor;
        Parties: _Ext.EmptyLookupEditor;
        VoucherNo: _Ext.EmptyLookupEditor;
        BagNo: _Ext.EmptyLookupEditor;
        AllVouchers: Serenity.BooleanEditor;
        ItemsOnly: Serenity.BooleanEditor;
    }

    export class ItemsRegisterFiltersForm extends Serenity.PrefixedContext {
        static formKey = 'Common.ItemsRegisterFilters';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ItemsRegisterFiltersForm.init)  {
                ItemsRegisterFiltersForm.init = true;

                var s = Serenity;
                var w0 = _Ext.EmptyLookupEditor;
                var w1 = s.BooleanEditor;

                Q.initFormType(ItemsRegisterFiltersForm, [
                    'VoucherTypeId', w0,
                    'Parties', w0,
                    'VoucherNo', w0,
                    'BagNo', w0,
                    'AllVouchers', w1,
                    'ItemsOnly', w1
                ]);
            }
        }
    }
}
